import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "app-table-name-renderer",
  templateUrl: "./category-item-render.component.html",
  // Without this, the host element defaults to `display: inline` (the browser default for an
  // unrecognized custom element), which breaks width:100% resolution for everything inside it —
  // the name span never gets a real width to wrap against, so line-clamp-2 has nothing to do and
  // long names just render at their natural width and get clipped by the cell's overflow:hidden.
  // Same fix already used by end-icon-renderer.component.ts for the same reason.
  host: { style: "display: block; width: 100%; height: 100%;" },
})
export class CategoryItemRenderComponent implements ICellRendererAngularComp {
  title!: string;
  transactionCount!: number;

  agInit(params: ICellRendererParams): void {
    this.setData(params);
  }

  setData(params: ICellRendererParams) {
    this.title = params.data.name || "Unavailable category name";
    this.transactionCount = params.data.linkedTransactionCount ?? 0;
  }

  refresh(params: ICellRendererParams): boolean {
    this.setData(params);
    return true;
  }
}
